export const SYN_MESSAGE = 'sdk-rpc-syn';
export const SYN_ACK_MESSAGE = 'sdk-rpc-syn-ack';
export const ACK_MESSAGE = 'sdk-rpc-ack';
export const SYN_SERVER_MESSAGE = 'sdk-rpc-syn-server';
export const FIN_MESSAGE = 'sdk-rpc-fin';
export const FIN_SERVER_MESSAGE = 'sdk-rpc-fin-server';

//# sourceMappingURL=constants.js.map